export default __webpack_public_path__ + "static/media/pgmico(12).5d7dfa98.png";